import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-layout',
  standalone: false,
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent {

  constructor(private router: Router) { }
  
  navigateToUsers() {
    this.router.navigate(['/admin/user-management']);
  }
  navigateToAudit() {
    this.router.navigate(['/admin/audit-log']);
  }

}
